











import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color, IColorSpecifiedFeature } from "../../../../../base/domain/drawing";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { ColorPicker } from "../../../../../base/components/drawing";

@Component({
  components: {
    ColorPicker,
  }
})
export default class PaintStyleOnEditingEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IColorSpecifiedFeature) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IColorSpecifiedFeature) => T, defaultValue: T) => T;

  @Prop()
  pallet: Color[];

  get isPaintStyleOnEditingEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  set isPaintStyleOnEditingEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isEnable = value);
  }

  get color(): Color {
    return this.readPropertyOrDefault(s => Color.from(s.color), new Color("transparent"));
  }

  set color(value: Color) {
    this.writePropertyWhenValid(s => s.color = Color.to(value));
  }

  get defaultColor(): Color {
    return new Color("transparent");
  }
}
